import refs from '../helpers/refs'
import Form from '../helpers/form'
import site from '../helpers/site'
import '../atoms/a-input-date'
import '../atoms/a-input-select'
import '../atoms/a-input-text'

class CProductRegistrationForm {
  constructor (el) {
    this.component = el
    this.$refs = refs(this.component)
    this.site = site()

    this.init()
  }

  init () {
    // Country/state behavior
    Form.handleCountryStateZip(this.$refs.countryDropdown)
    Form.handleCountrySubsidiary()
    // Email validation behavior
    Form.handleEmailFieldMatching()
    // Newsletter behavior
    Form.handleNewsletterOptIn()
    // File validation
    Form.handleFileValidation()

    if (this.site === 'masterbuilt') {
      // Product + type dropdowns
      Form.handleMBProductTypeDropdown()
      // Model number select or entry
      Form.handleMBModelNumber()
    } else if (this.site === 'chargriller') {
      // Product + type dropdowns
      Form.handleCGProductTypeDropdown()
      // Model number select or entry
      Form.handleCGModelNumber()
    } else {
      // Product + type dropdowns
      Form.handleKJProductTypeDropdown()
      // Model number select or entry
      Form.handleKJModelNumber()
    }

    this.component.querySelector('#support-form').addEventListener('submit', (event) => {
      const isValid = this.validateForm()

      if (!isValid) {
        event.preventDefault()
      } else {
        const zipFieldValue = document.querySelector('#zip-field').value
        // const helpTopicValue = document.querySelector('#help-topic').value
        // const helpTopicLabel = document.querySelector(`#help-topic option[value="${helpTopicValue}"]`).innerText
        const helpTopicLabel = 'Product registration'

        window.dataLayer.push({
          event: 'product_registration_form_submit',
          event_category: 'product_registration_form_submit',
          event_action: zipFieldValue,
          event_label: helpTopicLabel
        })
      }

      return isValid
    })
  }

  validateForm () {
    // change style of button so can tell it's been clicked
    document.querySelector('#submit-btn').setAttribute('disabled', true)
    document.querySelector('.please-wait').classList.remove('hidden')
    const purchaseDateField = document.getElementById('purchase-date-field')
    const zipField = document.getElementById('zip-field')
    const firstName = document.getElementById('first-name-field').value
    const lastName = document.getElementById('last-name-field').value
    let formIsValid = true

    // Clear previous error messages
    Form.hideAllErrors()

    // Check required fields
    formIsValid = Form.validateRequiredFields(this.component)

    if (formIsValid) {
      if (purchaseDateField.value.length > 0) {
        Form.formatDate(purchaseDateField)
      }

      if (!(formIsValid &&= Form.validZip(zipField.value))) {
        Form.showError(zipField.closest('.a-input-text'), window.customerServiceErrorStrings.invalid_zip)
      }

      formIsValid &&= Form.validateEmail()
      formIsValid &&= Form.validateFileSizes(['receipt', 'model', 'additional'])
      formIsValid &&= Form.validateFileFormat()
      formIsValid &&= Form.validateBannedName(firstName, lastName)
    }

    // re-enable submit button
    document.querySelector('#submit-btn').removeAttribute('disabled')
    document.querySelector('.please-wait').classList.add('hidden')

    if (!formIsValid) {
      // Set focus on the first error field
      Form.focusFirstError(this.component)
    }

    return formIsValid
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-product-registration')
    .forEach(el => new CProductRegistrationForm(el))
})
